(function () {
  var STORAGE_KEY = 'eh-theme';
  var root = document.documentElement;

  function prefersDark() {
    try {
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
    } catch (e) {
      // matchMedia unsupported/unavailable — fall back to light rather than
      // throwing and aborting the rest of this IIFE (which would leave the
      // toggle buttons permanently dead, since every click routes through
      // currentTheme() too).
      return false;
    }
  }

  function currentTheme() {
    var explicit = root.getAttribute('data-eh-theme');
    if (explicit === 'light' || explicit === 'dark') return explicit;
    return prefersDark() ? 'dark' : 'light';
  }

  // Screen readers can't see the sun/moon icon swap that communicates state
  // to sighted users — aria-pressed carries that same state to assistive
  // tech. Mobile browser chrome (address bar color) needs the same sync,
  // since it only follows prefers-color-scheme, not our manual override.
  function syncToggleButtons() {
    var pressed = String(currentTheme() === 'dark');
    var buttons = document.querySelectorAll('[data-eh-theme-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', pressed);
    }
  }

  function syncThemeColorMeta() {
    var content = currentTheme() === 'dark' ? '#0A0A0A' : '#FFFFFF';
    var metas = document.querySelectorAll('meta[name="theme-color"]');
    for (var i = 0; i < metas.length; i++) {
      metas[i].setAttribute('content', content);
    }
  }

  function setTheme(theme) {
    root.setAttribute('data-eh-theme', theme);
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      // localStorage unavailable — theme still applies for this page view via the attribute.
    }
    syncToggleButtons();
    syncThemeColorMeta();
  }

  function toggleTheme() {
    setTheme(currentTheme() === 'dark' ? 'light' : 'dark');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-eh-theme-toggle]');
    if (trigger) toggleTheme();
  });

  // The background/border CSS vars already react to a live OS theme change
  // via the @media query in eh-theme-tokens.liquid — no JS needed for that.
  // But aria-pressed and theme-color are JS-driven and only ran at load/
  // click, so they'd go stale (wrong state reported to screen readers and
  // mobile chrome) if the OS switches theme while the tab stays open with
  // no explicit data-eh-theme override in play.
  try {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function () {
      if (root.getAttribute('data-eh-theme')) return; // explicit override wins, nothing to resync
      syncToggleButtons();
      syncThemeColorMeta();
    });
  } catch (e) {
    // matchMedia/addEventListener unsupported — no live OS-change sync,
    // but must not throw here or the initial sync calls below never run.
  }

  syncToggleButtons();
  syncThemeColorMeta();
})();
